/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const RoledexCardIcons = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    onClick={props.onClick}
  >
    <g>
      <path d="M0.5,3.5 L0.5,19.5 L4.5,19.5 L4.5,18.75 C4.5,17.788 5.287,17 6.25,17 C7.212,17 8,17.788 8,18.75 L8,19.5 L16,19.5 L16,18.75 C16,17.788 16.787,17 17.75,17 C18.712,17 19.5,17.788 19.5,18.75 L19.5,19.5 L23.5,19.5 L23.5,3.5 L0.5,3.5 Z" />
      <circle cx="7" cy="8.5" r="2" />
      <path d="M7,10.5 C4.5,10.5 3.5,12 3.5,13.5 L10.5,13.5 C10.5,12 9.5,10.5 7,10.5 Z" />
      <path d="M13,13.5 L21,13.5" />
      <path d="M13,11.5 L21,11.5" />
      <path d="M13,9.5 L21,9.5" />
      <path d="M13,7.5 L17,7.5" />
    </g>
  </svg>
);

export default RoledexCardIcons;
